export const prepositions = new Set([
    'about',
    'above',
    'across',
    'after',
    'against',
    'along',
    'among',
    'around',
    'at',
    'before',
    'behind',
    'between',
    'beyond',
    'but',
    'by',
    'concerning',
    'despite',
    'down',
    'during',
    'except',
    'following',
    'for',
    'from',
    'in',
    'including',
    'into',
    'like',
    'near',
    'of',
    'off',
    'on',
    'onto',
    'out',
    'over',
    'past',
    'plus',
    'since',
    'throughout',
    'to	',
    'towards',
    'under',
    'until',
    'up	',
    'upon',
    'up',
    'to',
    'with',
    'within',
    'without',
]);
